import { createFileRoute } from '@tanstack/react-router';
import { OrganizationShipmentSettings } from '@uturn/portal/modules/org/pages/shipment-settings';

export const Route = createFileRoute(
	'/_protected/org/$orgId/settings/shipment-settings',
)({
	component: OrganizationShipmentSettings,
});
